import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import type { FullPostType } from 'src/app/pages/starterDashboardV2/shared/components';

const GROUP_SELECT_MODAL_VIEW_EVENT_NAME = 'petition_manage_ready_to_share_group_select_modal_view';

type UseGroupSelectionTrackingParams = {
	selectedTab: string;
};

type UseGroupSelectionTrackingResult = {
	trackGroupSelection: (fullPostType: FullPostType) => void;
};

function mapFullPostTypeToLocation(fullPostType: FullPostType): 'facebook_group' | 'reddit_group' {
	if (fullPostType === 'facebook_group_post') {
		return 'facebook_group';
	}
	return 'reddit_group';
}

export function useGroupSelectionTracking({
	selectedTab,
}: UseGroupSelectionTrackingParams): UseGroupSelectionTrackingResult {
	const track = useTracking();

	const trackGroupSelection = useCallback(
		(fullPostType: FullPostType) => {
			const location = mapFullPostTypeToLocation(fullPostType);
			void track(GROUP_SELECT_MODAL_VIEW_EVENT_NAME, {
				context: 'petition_dashboard_ready_to_share_post',
				view_context: selectedTab,
				location,
			});
		},
		[track, selectedTab],
	);

	return {
		trackGroupSelection,
	};
}
